import React from 'react';
import { bool, string } from 'prop-types';
import { Field } from 'react-final-form';
import classNames from 'classnames';

import { intlShape } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import * as validators from '../../util/validators';
import { FieldCheckbox, FieldRadioButton, FieldSelect, Icons, NamedLink } from '../../components';

import css from './AuthenticationPage.module.css';
import { extraUserTypeOptions } from '../../config/configExtras';

// Hidden input field
const FieldHidden = props => {
  const { name } = props;
  return (
    <Field id={name} name={name} type="hidden" className={css.unitTypeHidden}>
      {fieldRenderProps => <input {...fieldRenderProps?.input} />}
    </Field>
  );
};

/**
 * Return React Final Form Field that allows selecting user type.
 *
 * @param {*} props containing name, userTypes, hasExistingUserType, intl
 * @returns React Final Form Field component to select user type
 */
const FieldSelectUserType = props => {
  const { rootClassName, className, name, userTypes, hasExistingUserType, intl } = props;
  const hasMultipleUserTypes = userTypes?.length > 1;
  const classes = classNames(rootClassName || css.userTypeSelect, className);

  return hasMultipleUserTypes && !hasExistingUserType ? (
    <>
      <div className={css.fieldRadioContainer}>
        {userTypes.map(config => {
          const type = config.userType;
          const extraDetails = extraUserTypeOptions.find(o => o.userType === type);
          return (
            <NamedLink
              key={type}
              className={css.radioCard}
              name="SignupForUserTypePage"
              params={{ userType: type }}
            >
              <FieldRadioButton
                key={type}
                id={`radio-${type}`}
                name={name}
                label={
                  <div className={css.userTypeContent}>
                    <h2>{config.label}</h2>
                    <p>{intl.formatMessage({ id: extraDetails.labelId })}</p>
                  </div>
                }
                value={type}
                showAsRequired={true}
                validate={validators.required(
                  intl.formatMessage({ id: 'FieldSelectUserType.required' })
                )}
                userTypeIcon={
                  <div className={css.userTypeIcon}>
                    <Icons name={type} />
                  </div>
                }
              />
            </NamedLink>
          );
        })}
      </div>
    </>
  ) : (
    <>
      <FieldHidden name={name} />
    </>
  );
};

FieldSelectUserType.defaultProps = {
  rootClassName: null,
  className: null,
  hasExistingUserType: false,
};

FieldSelectUserType.propTypes = {
  rootClassName: string,
  className: string,
  name: string.isRequired,
  userTypes: propTypes.userTypes.isRequired,
  hasExistingUserType: bool,
  intl: intlShape.isRequired,
};

export default FieldSelectUserType;
